import { render, staticRenderFns } from "./FormEndereco.vue?vue&type=template&id=1df6ca51&scoped=true&"
import script from "./FormEndereco.vue?vue&type=script&lang=js&"
export * from "./FormEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6ca51",
  null
  
)

export default component.exports